import { Trans } from '@lingui/macro';
import { Wifi, WifiOff } from 'lucide-react';
import { useNetworkStatus } from '@shared/lib/network-status';

export const NetworkStatusBanner = () => {
  const { isOnline, showOnlineRestored } = useNetworkStatus();

  if (isOnline && !showOnlineRestored) {
    return null;
  }

  const Icon = isOnline ? Wifi : WifiOff;

  return (
    <div
      role='status'
      aria-live='polite'
      className={`sticky top-2 z-40 mx-2 shrink-0 rounded-xl border px-3 py-2 shadow-sm backdrop-blur ${
        isOnline
          ? 'border-emerald-200 bg-emerald-50/95 text-emerald-950 dark:border-emerald-900/60 dark:bg-emerald-950/95 dark:text-emerald-100'
          : 'border-red-200 bg-red-50/95 text-red-950 dark:border-red-900/60 dark:bg-red-950/95 dark:text-red-100'
      }`}
    >
      <div className='flex w-full items-center gap-3 text-sm'>
        <span
          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full ${
            isOnline
              ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/70 dark:text-emerald-200'
              : 'bg-red-100 text-red-700 dark:bg-red-900/70 dark:text-red-200'
          }`}
        >
          <Icon className='h-4 w-4' aria-hidden='true' />
        </span>
        <div className='min-w-0 leading-tight'>
          <span className='block font-semibold'>
            {isOnline ? (
              <Trans id='shared.layout.NetworkStatusBanner.online-title'>Online</Trans>
            ) : (
              <Trans id='shared.layout.NetworkStatusBanner.offline-title'>Offline</Trans>
            )}
          </span>
          <span className='block text-xs opacity-90 sm:text-sm'>
            {isOnline ? (
              <Trans id='shared.layout.NetworkStatusBanner.online-description'>
                You are back online. Everything is ready.
              </Trans>
            ) : (
              <Trans id='shared.layout.NetworkStatusBanner.offline-description'>
                You are offline. We'll reconnect automatically when your connection returns.
              </Trans>
            )}
          </span>
        </div>
      </div>
    </div>
  );
};
